import React from 'react'

const aboutus = () => {
  return (
    <div>
    <div className='aboutus' id='about'>
      <h2>About Us</h2>
      <div className='about-text'>
      <h1>KAON Professional</h1>
      <h5>Healthy hair that looks attractive can make you feel confident and super attractive. <br/>Shiny and Strong hair makes you the cynosure of all eyes.</h5>
      <p>You have enough to worry about, let your hair be the least of it. Gorgeous looks? You can have it! With KAON PROFESSIONAL, treat yourself to beautiful hair and luxury products. <br/>When it comes to KAON Professional Keratin Treatments the difference is as clear as H2O, scroll down to explore more.</p>
      <button className='button'>Read More</button>
      </div>
    </div>
    </div>
  )
}

export default aboutus
